/**
 * Conflict resolution hooks — list + resolve/dismiss mutations.
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  buddyGroupAdminKeys,
  fetchRodeoConflicts,
  resolveConflict,
} from '../buddy-group-service';
import type { ResolveConflictPayload } from '../../types/conflict';

export function useRodeoConflicts(rodeoId: string) {
  return useQuery({
    queryKey: buddyGroupAdminKeys.conflicts(rodeoId),
    queryFn: () => fetchRodeoConflicts(rodeoId),
    enabled: !!rodeoId,
  });
}

export function useResolveConflict() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      conflictId,
      payload,
    }: {
      conflictId: string;
      payload: ResolveConflictPayload;
    }) => resolveConflict(conflictId, payload),
    onSuccess: () => {
      // Invalidate all conflict queries since we don't know the rodeoId here
      qc.invalidateQueries({ queryKey: buddyGroupAdminKeys.all });
    },
  });
}
